// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/**
 * A simple function that does nothing and returns the current this (if any).
 * @returns
 */
export function _noopThis() {
    return this;
}
/**
 * A simple function that does nothing and returns undefined.
 */
export function _noopVoid() {
}
//# sourceMappingURL=noopHelpers.js.map